/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * Actions for Bills
 *
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.25.0
 */

import { createAction } from '@/main/modules/app/createAction';

import { BILLS_INIT_ONBOARDING } from './billsConstants';
import { TInitBillsOnboardingAction } from './billsTypes';

/*
 * -------------------------------------------
 *           ONBOARDING
 * -------------------------------------------
 */

export const initBillsOnboarding = (): TInitBillsOnboardingAction => createAction(BILLS_INIT_ONBOARDING);
